import { ButtonClientManagement } from './Button';

export const Button = ButtonClientManagement;
